export default class AuthAPI {
	static API_Authenticate() {
		return `/api/authenticate`;
	}
	static API_ReLogin(refreshToken) {
		return `/api/re-login?refreshToken=${refreshToken}`;
	}
	static API_Logout(refreshToken) {
		return `/api/logout?refreshToken=${refreshToken}`;
	}
}
